import React, { useEffect, useState } from 'react';
import { Dialog, Loading, OverlayTrigger, PopOver } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { genBasicHooks } from '../../../leads_component/shared-components/plugins/helper';
import useInput from '../../../leads_component/shared-components/hooks/useInput';
import { useInputMaxCharLengthPlugin } from '../../../leads_component/shared-components/plugins/input-plugins';
import MyInput from '../../common/maxLengthInput';

const Page = (props) => {
  const { wxAppId } = props;

  const [loading, setLoading] = useState(true);
  const [operating, setOperating] = useState(false);
  const [reload, setReload] = useState(0);
  const [tagList, setTagList] = useState([]);

  // 模式，用于展示提示层
  // 枚举：新建标签('add')/编辑标签('update')/删除标签('delete')/无('')
  const [mode, setMode] = useState('');

  useEffect(() => {
    if (wxAppId !== null) {
      setLoading(true);
      RPCFactory.wechatTagManagement
        .userTagList(wxAppId, {})
        .done((data) => {
          setTagList(data.entities);
        })
        .fail((code, msg) => {
          alert(msg);
        })
        .always(() => {
          setLoading(false);
        });
    }
  }, [wxAppId, reload]);

  const nameHooks = genBasicHooks(useInput, {
    required: true,
  }).usePlugin(useInputMaxCharLengthPlugin, { maxLength: 20 });

  const createTag = () => {
    if (!nameHooks.checkValid()) {
      return;
    }
    setOperating(true);
    RPCFactory.wechatTagManagement
      .add(wxAppId, nameHooks.value)
      .done((data) => {
        setTagList(tagList.concat({ tagId: data, tagName: nameHooks.value }));
      })
      .fail((code, msg) => {
        alert(msg);
      })
      .always(() => {
        setOperating(false);
        setMode('');
      });
  };

  const updateTag = (tagId) => {
    if (!nameHooks.checkValid()) {
      return;
    }
    setOperating(true);
    RPCFactory.wechatTagManagement
      .update(wxAppId, tagId, nameHooks.value)
      .done((data) => {
        tagList.forEach((e) => {
          if (e.tagId == tagId) {
            e.tagName = nameHooks.value;
          }
        });
        setTagList([].concat(tagList));
      })
      .fail((code, msg) => {
        alert(msg);
      })
      .always(() => {
        setOperating(false);
        setMode('');
      });
  };

  const deleteTag = (tagId) => {
    setOperating(true);
    RPCFactory.wechatTagManagement
      .delete(wxAppId, tagId)
      .done((data) => {
        setTagList(tagList.filter((e) => e.tagId !== tagId));
      })
      .fail((code, msg) => {
        alert(msg);
      })
      .always(() => {
        setOperating(false);
        setMode('');
      });
  };

  const handleClose = () => {
    if (props.handleClose && typeof props.handleClose === 'function') {
      props.handleClose();
    }
  };

  const [activeTagId, setActiveTagId] = useState();
  const tagli = [];
  tagList.forEach((tag) => {
    if (![0, 1, 2].includes(tag.tagId) && activeTagId == tag.tagId) {
      tagli.push(
        <li
          className="tags action"
          onMouseOver={() => {
            setActiveTagId(tag.tagId);
          }}
          onMouseLeave={() => {
            setActiveTagId(undefined);
            setMode('');
          }}
        >
          <div className="inner">{tag.tagName}</div>
          <div className="inner-action">
            {tag.tagName}
            <OverlayTrigger
              trigger="click"
              documentClickAutoHide="false"
              show={mode == 'update'}
              onShowChange={(event, show) => {
                if (show) {
                  nameHooks.setValue(tag.tagName);
                }
              }}
              overlay={
                <PopOver className="with-btns">
                  <div className="spaui-popover-body">
                    <MyInput placeholder="输入标签名称" {...nameHooks.props} />
                  </div>
                  <div className="spaui-popover-btns">
                    <a
                      className="btn btn-default"
                      onClick={() => {
                        setMode('');
                      }}
                    >
                      取消
                    </a>
                    <a
                      className="btn btn-primary"
                      onClick={() => {
                        updateTag(tag.tagId);
                      }}
                    >
                      确定
                    </a>
                  </div>
                </PopOver>
              }
            >
              <i
                className="icon icon-pen"
                onClick={() => {
                  setMode('update');
                }}
              ></i>
            </OverlayTrigger>
            <OverlayTrigger
              trigger="click"
              documentClickAutoHide="false"
              show={mode == 'delete'}
              overlay={
                <PopOver className="with-btns">
                  <div className="spaui-popover-body">删除标签后，粉丝关联的规则也将失效。确定删除此标签吗？</div>
                  <div className="spaui-popover-btns">
                    <a
                      className="btn btn-default"
                      onClick={() => {
                        setMode('');
                      }}
                    >
                      取消
                    </a>
                    <a
                      className="btn btn-primary"
                      onClick={() => {
                        deleteTag(tag.tagId);
                      }}
                    >
                      确定
                    </a>
                  </div>
                </PopOver>
              }
            >
              <i
                className="icon icon-del"
                onClick={() => {
                  setMode('delete');
                }}
              ></i>
            </OverlayTrigger>
          </div>
        </li>,
      );
    } else {
      tagli.push(
        <li
          className="tags"
          onMouseOver={() => {
            setActiveTagId(tag.tagId);
          }}
          onMouseLeave={() => {
            setActiveTagId(undefined);
          }}
        >
          <div className="inner">{tag.tagName}</div>
          <div className="inner-action">
            {tag.tagName}
            <i className="icon icon-pen"></i>
            <i className="icon icon-del"></i>
          </div>
        </li>,
      );
    }
  });

  return (
    <div>
      <Dialog
        backdrop
        type="normal"
        show={true}
        className="modal-set-height"
        onClose={handleClose}
        cancelButton={false}
        submitButton={false}
        title="标签管理"
        style={{ width: '560px' }}
      >
        <div className="tagrule-new">
          {loading ? (
            <Loading show={loading} type="svg" />
          ) : (
            <ul className="tags-lump clearfix">
              {tagli}
              <li className="tags">
                <div className="inner">
                  <OverlayTrigger
                    trigger="click"
                    documentClickAutoHide="false"
                    show={mode == 'add'}
                    onShowChange={(event, show) => {
                      if (show) {
                        nameHooks.setValue('');
                      }
                    }}
                    overlay={
                      <PopOver className="with-btns">
                        <div className="spaui-popover-body">
                          <MyInput placeholder="输入标签名称" {...nameHooks.props} />
                        </div>
                        <div className="spaui-popover-btns">
                          <a
                            className="btn btn-default"
                            onClick={() => {
                              setMode('');
                            }}
                          >
                            取消
                          </a>
                          <a
                            className="btn btn-primary"
                            onClick={() => {
                              createTag();
                            }}
                          >
                            确定
                          </a>
                        </div>
                      </PopOver>
                    }
                  >
                    <a
                      onClick={() => {
                        setMode('add');
                      }}
                    >
                      + 新建标签
                    </a>
                  </OverlayTrigger>
                </div>
              </li>
            </ul>
          )}
        </div>
      </Dialog>
      <Loading show={operating} type="page" />
    </div>
  );
};

export default Page;
